import React, { memo } from 'react'
import { Box, Stack } from '@mui/material'
import CustomLinearProgress from './CustomLinearProgress'

const CustomProgressBar = ({
  title,
  label,
  completed,
  progressTextSx,
  height,
  rightLabel
}) => {
  return (
    <Box
      sx={{
        minWidth: 0,
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        width: '100%'
      }}
    >
      <Stack
        direction='row'
        sx={{ justifyContent: 'space-between', flexWrap: 'wrap' }}
      >
        <Stack>
          {title}
          <Box
            component='span'
            sx={{
              color: 'text.secondary',
              typography: 'caption',
              ...progressTextSx
            }}
          >
            {label}
          </Box>
        </Stack>
        {rightLabel}
      </Stack>
      <Box
        sx={{
          width: 1,
          display: 'flex',
          alignItems: 'center',
          gap: 2
        }}
      >
        <CustomLinearProgress completed={completed} height={height} />
        <Box
          component='span'
          sx={{
            width: 40,
            typography: 'caption',
            color: 'text.secondary',
            fontWeight: 'fontWeightMedium',
            ...progressTextSx
          }}
        >
          {completed}%
        </Box>
      </Box>
    </Box>
  )
}

export default memo(CustomProgressBar)
